/* tslint:disable */
/* eslint-disable */
/**
 * Search v2
 * Search v2
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../../../runtime';
import type { AssetResponse, AssetsExportResponse, Data360ExportRequest, Data360SearchRequest, Scheme, SingleAssetResponse } from '../models';

export interface ExportAssetsRequest {
	knowledgeQuery: string;
	segments: Array<ExportAssetsSegments>;
	data360ExportRequest: Data360ExportRequest;
	xINFAORGID?: string;
	fileName?: string;
	summaryViews?: Array<ExportAssetsSummaryViews>;
}

export interface ExportMultiAssetDetailsRequest {
	scheme: Scheme;
	segments: Array<ExportMultiAssetDetailsSegments>;
	requestBody: Set<string>;
	xINFAORGID?: string;
	fileName?: string;
	summaryViews?: Array<ExportMultiAssetDetailsSummaryViews>;
}

export interface GetAssetDetailsRequest {
	id: string;
	scheme: Scheme;
	segments: Array<string>;
	xINFAORGID?: string;
}

export interface GetAssetsRequest {
	knowledgeQuery: string;
	segments: Array<GetAssetsSegments>;
	data360SearchRequest: Data360SearchRequest;
	xINFAORGID?: string;
}

export interface GetMultiAssetDetailsRequest {
	scheme: Scheme;
	segments: Array<string>;
	requestBody: Set<string>;
	xINFAORGID?: string;
}

/**
 *
 */
export class Data360ExplorerApi extends runtime.BaseAPI {
	/**
	 * Export Assets listed by Search Query
	 */
	async exportAssetsRaw(
		requestParameters: ExportAssetsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction,
	): Promise<runtime.ApiResponse<AssetsExportResponse>> {
		if (requestParameters.knowledgeQuery === null || requestParameters.knowledgeQuery === undefined) {
			throw new runtime.RequiredError('knowledgeQuery', 'Required parameter requestParameters.knowledgeQuery was null or undefined when calling exportAssets.');
		}

		if (requestParameters.segments === null || requestParameters.segments === undefined) {
			throw new runtime.RequiredError('segments', 'Required parameter requestParameters.segments was null or undefined when calling exportAssets.');
		}

		if (requestParameters.data360ExportRequest === null || requestParameters.data360ExportRequest === undefined) {
			throw new runtime.RequiredError(
				'data360ExportRequest',
				'Required parameter requestParameters.data360ExportRequest was null or undefined when calling exportAssets.',
			);
		}

		const queryParameters: any = {};

		if (requestParameters.knowledgeQuery !== undefined) {
			queryParameters['knowledgeQuery'] = requestParameters.knowledgeQuery;
		}

		if (requestParameters.fileName !== undefined) {
			queryParameters['fileName'] = requestParameters.fileName;
		}

		if (requestParameters.segments) {
			queryParameters['segments'] = requestParameters.segments;
		}

		if (requestParameters.summaryViews) {
			queryParameters['summaryViews'] = requestParameters.summaryViews;
		}

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xINFAORGID !== undefined && requestParameters.xINFAORGID !== null) {
			headerParameters['X-INFA-ORG-ID'] = String(requestParameters.xINFAORGID);
		}

		if (this.configuration && this.configuration.apiKey) {
			headerParameters['IDS-USER-TOKEN'] = this.configuration.apiKey('IDS-USER-TOKEN'); // userToken authentication
		}

		if (this.configuration && this.configuration.apiKey) {
			headerParameters['IDS-AGENT-SESSION-ID'] = this.configuration.apiKey('IDS-AGENT-SESSION-ID'); // agentSessionId authentication
		}

		if (this.configuration && this.configuration.apiKey) {
			headerParameters['IDS-SERVICE-TOKEN'] = this.configuration.apiKey('IDS-SERVICE-TOKEN'); // serviceToken authentication
		}

		if (this.configuration && this.configuration.accessToken) {
			const token = this.configuration.accessToken;
			const tokenString = await token('bearerAuth', []);

			if (tokenString) {
				headerParameters['Authorization'] = `Bearer ${tokenString}`;
			}
		}
		const response = await this.request(
			{
				path: `/export/v1/assets`,
				method: 'POST',
				headers: headerParameters,
				query: queryParameters,
				body: requestParameters.data360ExportRequest,
			},
			initOverrides,
		);

		return new runtime.JSONApiResponse(response);
	}

	/**
	 * Export Assets listed by Search Query
	 */
	async exportAssets(requestParameters: ExportAssetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetsExportResponse> {
		const response = await this.exportAssetsRaw(requestParameters, initOverrides);
		return await response.value();
	}

	/**
	 * Export Multi Asset Details
	 */
	async exportMultiAssetDetailsRaw(
		requestParameters: ExportMultiAssetDetailsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction,
	): Promise<runtime.ApiResponse<AssetsExportResponse>> {
		if (requestParameters.scheme === null || requestParameters.scheme === undefined) {
			throw new runtime.RequiredError('scheme', 'Required parameter requestParameters.scheme was null or undefined when calling exportMultiAssetDetails.');
		}

		if (requestParameters.segments === null || requestParameters.segments === undefined) {
			throw new runtime.RequiredError('segments', 'Required parameter requestParameters.segments was null or undefined when calling exportMultiAssetDetails.');
		}

		if (requestParameters.requestBody === null || requestParameters.requestBody === undefined) {
			throw new runtime.RequiredError(
				'requestBody',
				'Required parameter requestParameters.requestBody was null or undefined when calling exportMultiAssetDetails.',
			);
		}

		const queryParameters: any = {};

		if (requestParameters.fileName !== undefined) {
			queryParameters['fileName'] = requestParameters.fileName;
		}

		if (requestParameters.scheme !== undefined) {
			queryParameters['scheme'] = requestParameters.scheme;
		}

		if (requestParameters.segments) {
			queryParameters['segments'] = requestParameters.segments;
		}

		if (requestParameters.summaryViews) {
			queryParameters['summaryViews'] = requestParameters.summaryViews;
		}

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xINFAORGID !== undefined && requestParameters.xINFAORGID !== null) {
			headerParameters['X-INFA-ORG-ID'] = String(requestParameters.xINFAORGID);
		}

		if (this.configuration && this.configuration.apiKey) {
			headerParameters['IDS-USER-TOKEN'] = this.configuration.apiKey('IDS-USER-TOKEN'); // userToken authentication
		}

		if (this.configuration && this.configuration.apiKey) {
			headerParameters['IDS-AGENT-SESSION-ID'] = this.configuration.apiKey('IDS-AGENT-SESSION-ID'); // agentSessionId authentication
		}

		if (this.configuration && this.configuration.apiKey) {
			headerParameters['IDS-SERVICE-TOKEN'] = this.configuration.apiKey('IDS-SERVICE-TOKEN'); // serviceToken authentication
		}

		if (this.configuration && this.configuration.accessToken) {
			const token = this.configuration.accessToken;
			const tokenString = await token('bearerAuth', []);

			if (tokenString) {
				headerParameters['Authorization'] = `Bearer ${tokenString}`;
			}
		}
		const response = await this.request(
			{
				path: `/export/v1/assets/details`,
				method: 'POST',
				headers: headerParameters,
				query: queryParameters,
				body: requestParameters.requestBody,
			},
			initOverrides,
		);

		return new runtime.JSONApiResponse(response);
	}

	/**
	 * Export Multi Asset Details
	 */
	async exportMultiAssetDetails(
		requestParameters: ExportMultiAssetDetailsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction,
	): Promise<AssetsExportResponse> {
		const response = await this.exportMultiAssetDetailsRaw(requestParameters, initOverrides);
		return await response.value();
	}

	/**
	 * Get Asset Details
	 */
	async getAssetDetailsRaw(
		requestParameters: GetAssetDetailsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction,
	): Promise<runtime.ApiResponse<SingleAssetResponse>> {
		if (requestParameters.id === null || requestParameters.id === undefined) {
			throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getAssetDetails.');
		}

		if (requestParameters.scheme === null || requestParameters.scheme === undefined) {
			throw new runtime.RequiredError('scheme', 'Required parameter requestParameters.scheme was null or undefined when calling getAssetDetails.');
		}

		if (requestParameters.segments === null || requestParameters.segments === undefined) {
			throw new runtime.RequiredError('segments', 'Required parameter requestParameters.segments was null or undefined when calling getAssetDetails.');
		}

		const queryParameters: any = {};

		if (requestParameters.scheme !== undefined) {
			queryParameters['scheme'] = requestParameters.scheme;
		}

		if (requestParameters.segments) {
			queryParameters['segments'] = requestParameters.segments;
		}

		const headerParameters: runtime.HTTPHeaders = {};

		if (requestParameters.xINFAORGID !== undefined && requestParameters.xINFAORGID !== null) {
			headerParameters['X-INFA-ORG-ID'] = String(requestParameters.xINFAORGID);
		}

		if (this.configuration && this.configuration.apiKey) {
			headerParameters['IDS-USER-TOKEN'] = this.configuration.apiKey('IDS-USER-TOKEN'); // userToken authentication
		}

		if (this.configuration && this.configuration.apiKey) {
			headerParameters['IDS-AGENT-SESSION-ID'] = this.configuration.apiKey('IDS-AGENT-SESSION-ID'); // agentSessionId authentication
		}

		if (this.configuration && this.configuration.apiKey) {
			headerParameters['IDS-SERVICE-TOKEN'] = this.configuration.apiKey('IDS-SERVICE-TOKEN'); // serviceToken authentication
		}

		if (this.configuration && this.configuration.accessToken) {
			const token = this.configuration.accessToken;
			const tokenString = await token('bearerAuth', []);

			if (tokenString) {
				headerParameters['Authorization'] = `Bearer ${tokenString}`;
			}
		}
		const response = await this.request(
			{
				path: `/v1/assets/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id))),
				method: 'GET',
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides,
		);

		return new runtime.JSONApiResponse(response);
	}

	/**
	 * Get Asset Details
	 */
	async getAssetDetails(requestParameters: GetAssetDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SingleAssetResponse> {
		const response = await this.getAssetDetailsRaw(requestParameters, initOverrides);
		return await response.value();
	}

	/**
	 * Get Assets listed by Search Query
	 */
	async getAssetsRaw(
		requestParameters: GetAssetsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction,
	): Promise<runtime.ApiResponse<AssetResponse>> {
		if (requestParameters.knowledgeQuery === null || requestParameters.knowledgeQuery === undefined) {
			throw new runtime.RequiredError('knowledgeQuery', 'Required parameter requestParameters.knowledgeQuery was null or undefined when calling getAssets.');
		}

		if (requestParameters.segments === null || requestParameters.segments === undefined) {
			throw new runtime.RequiredError('segments', 'Required parameter requestParameters.segments was null or undefined when calling getAssets.');
		}

		if (requestParameters.data360SearchRequest === null || requestParameters.data360SearchRequest === undefined) {
			throw new runtime.RequiredError(
				'data360SearchRequest',
				'Required parameter requestParameters.data360SearchRequest was null or undefined when calling getAssets.',
			);
		}

		const queryParameters: any = {};

		if (requestParameters.knowledgeQuery !== undefined) {
			queryParameters['knowledgeQuery'] = requestParameters.knowledgeQuery;
		}

		if (requestParameters.segments) {
			queryParameters['segments'] = requestParameters.segments;
		}

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xINFAORGID !== undefined && requestParameters.xINFAORGID !== null) {
			headerParameters['X-INFA-ORG-ID'] = String(requestParameters.xINFAORGID);
		}

		if (this.configuration && this.configuration.apiKey) {
			headerParameters['IDS-USER-TOKEN'] = this.configuration.apiKey('IDS-USER-TOKEN'); // userToken authentication
		}

		if (this.configuration && this.configuration.apiKey) {
			headerParameters['IDS-AGENT-SESSION-ID'] = this.configuration.apiKey('IDS-AGENT-SESSION-ID'); // agentSessionId authentication
		}

		if (this.configuration && this.configuration.apiKey) {
			headerParameters['IDS-SERVICE-TOKEN'] = this.configuration.apiKey('IDS-SERVICE-TOKEN'); // serviceToken authentication
		}

		if (this.configuration && this.configuration.accessToken) {
			const token = this.configuration.accessToken;
			const tokenString = await token('bearerAuth', []);

			if (tokenString) {
				headerParameters['Authorization'] = `Bearer ${tokenString}`;
			}
		}
		const response = await this.request(
			{
				path: `/v1/assets`,
				method: 'POST',
				headers: headerParameters,
				query: queryParameters,
				body: requestParameters.data360SearchRequest,
			},
			initOverrides,
		);

		return new runtime.JSONApiResponse(response);
	}

	/**
	 * Get Assets listed by Search Query
	 */
	async getAssets(requestParameters: GetAssetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetResponse> {
		const response = await this.getAssetsRaw(requestParameters, initOverrides);
		return await response.value();
	}

	/**
	 * Get Multi Asset Details
	 */
	async getMultiAssetDetailsRaw(
		requestParameters: GetMultiAssetDetailsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction,
	): Promise<runtime.ApiResponse<Array<SingleAssetResponse>>> {
		if (requestParameters.scheme === null || requestParameters.scheme === undefined) {
			throw new runtime.RequiredError('scheme', 'Required parameter requestParameters.scheme was null or undefined when calling getMultiAssetDetails.');
		}

		if (requestParameters.segments === null || requestParameters.segments === undefined) {
			throw new runtime.RequiredError('segments', 'Required parameter requestParameters.segments was null or undefined when calling getMultiAssetDetails.');
		}

		if (requestParameters.requestBody === null || requestParameters.requestBody === undefined) {
			throw new runtime.RequiredError(
				'requestBody',
				'Required parameter requestParameters.requestBody was null or undefined when calling getMultiAssetDetails.',
			);
		}

		const queryParameters: any = {};

		if (requestParameters.scheme !== undefined) {
			queryParameters['scheme'] = requestParameters.scheme;
		}

		if (requestParameters.segments) {
			queryParameters['segments'] = requestParameters.segments;
		}

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xINFAORGID !== undefined && requestParameters.xINFAORGID !== null) {
			headerParameters['X-INFA-ORG-ID'] = String(requestParameters.xINFAORGID);
		}

		if (this.configuration && this.configuration.apiKey) {
			headerParameters['IDS-USER-TOKEN'] = this.configuration.apiKey('IDS-USER-TOKEN'); // userToken authentication
		}

		if (this.configuration && this.configuration.apiKey) {
			headerParameters['IDS-AGENT-SESSION-ID'] = this.configuration.apiKey('IDS-AGENT-SESSION-ID'); // agentSessionId authentication
		}

		if (this.configuration && this.configuration.apiKey) {
			headerParameters['IDS-SERVICE-TOKEN'] = this.configuration.apiKey('IDS-SERVICE-TOKEN'); // serviceToken authentication
		}

		if (this.configuration && this.configuration.accessToken) {
			const token = this.configuration.accessToken;
			const tokenString = await token('bearerAuth', []);

			if (tokenString) {
				headerParameters['Authorization'] = `Bearer ${tokenString}`;
			}
		}
		const response = await this.request(
			{
				path: `/v1/assets/details`,
				method: 'POST',
				headers: headerParameters,
				query: queryParameters,
				body: requestParameters.requestBody,
			},
			initOverrides,
		);

		return new runtime.JSONApiResponse(response);
	}

	/**
	 * Get Multi Asset Details
	 */
	async getMultiAssetDetails(
		requestParameters: GetMultiAssetDetailsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction,
	): Promise<Array<SingleAssetResponse>> {
		const response = await this.getMultiAssetDetailsRaw(requestParameters, initOverrides);
		return await response.value();
	}
}

/**
 * @export
 * @enum {string}
 */
export enum ExportAssetsSegments {
	All = 'all',
	Summary = 'summary',
	SystemAttributes = 'systemAttributes',
	Stakeholdership = 'stakeholdership',
	CustomAttributes = 'customAttributes',
	SelfAttributes = 'selfAttributes',
	DataProfile = 'dataProfile',
	DataClassification = 'dataClassification',
	Glossary = 'glossary',
	DataQuality = 'dataQuality',
	Hierarchy = 'hierarchy',
}
/**
 * @export
 * @enum {string}
 */
export enum ExportAssetsSummaryViews {
	All = 'All',
	Technical = 'Technical',
	Business = 'Business',
}
/**
 * @export
 * @enum {string}
 */
export enum ExportMultiAssetDetailsSegments {
	All = 'all',
	Summary = 'summary',
	SystemAttributes = 'systemAttributes',
	Stakeholdership = 'stakeholdership',
	CustomAttributes = 'customAttributes',
	SelfAttributes = 'selfAttributes',
	DataProfile = 'dataProfile',
	DataClassification = 'dataClassification',
	Glossary = 'glossary',
	DataQuality = 'dataQuality',
	Hierarchy = 'hierarchy',
	Neighborhood = 'neighborhood',
}
/**
 * @export
 * @enum {string}
 */
export enum ExportMultiAssetDetailsSummaryViews {
	All = 'All',
	Technical = 'Technical',
	Business = 'Business',
}
/**
 * @export
 * @enum {string}
 */
export enum GetAssetsSegments {
	Summary = 'summary',
	SystemAttributes = 'systemAttributes',
	CustomAttributes = 'customAttributes',
	SelfAttributes = 'selfAttributes',
	Details = 'details',
	All = 'all',
}
